import React, { FC, HTMLProps } from 'react'
import { StyledWrapper } from './Wrapper.styles'

export const Wrapper: FC<Omit<HTMLProps<HTMLDivElement>, 'ref' | 'type' | 'as'>> = ({ ...props }) => (
  <StyledWrapper {...props} />
)
